import {cn} from '@bem-react/classname';

export const cnFacadeMaterials = cn('FacadeMaterials');